import { HttpClient } from '@angular/common/http';
import { APIBaseManager } from '../../api.base';

export interface IDeviceAdvanceExportTxData {
    virtualDeviceIDList: string[];
}

export class APIDeviceAdvanceExportManager extends APIBaseManager<void, void, IDeviceAdvanceExportTxData, string[][]> {
    constructor(protected http: HttpClient) {
        super(http);
        this._apiName = 'API_DeviceAdvanceExport';
        this._apiMethod = 'POST';
    }

    protected getRequestURL(pathParameters: void, queryParameters: void): string {
        return super.getRequestURL() + 'virtualDevices/workaroundExport';
    }
}